import React, { createContext, useContext, useMemo, useState } from 'react'
import { useDetectedMarket } from '../../hooks/useDetectedMarket'

export type SelectedMarket = {
  marketId: number
  marketName: string
}

type MarketContextValue = {
  market: SelectedMarket | null
  setMarket: (market: SelectedMarket | null) => void
  isDetected: boolean
  isLoading: boolean
}

const MarketContext = createContext<MarketContextValue | null>(null)

export const MarketProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { data: detected, isLoading } = useDetectedMarket()
  const [override, setOverride] = useState<SelectedMarket | null>(null)

  const value = useMemo<MarketContextValue>(
    () => ({
      market: override ?? detected,
      setMarket: setOverride,
      isDetected: override === null && detected !== null,
      isLoading,
    }),
    [override, detected, isLoading],
  )

  return (
    <MarketContext.Provider value={value}>{children}</MarketContext.Provider>
  )
}

export function useSelectedMarket(): MarketContextValue {
  const ctx = useContext(MarketContext)
  if (!ctx)
    throw new Error('useSelectedMarket must be used inside <MarketProvider>')
  return ctx
}
